<template>

  <v-radio-group
    v-bind="{ ...$attrs, ...commonAttrs }"
  >
    
    <v-radio
      v-for="item in items"
      :label="item.title"
      :value="item.value"
    />

  </v-radio-group>

</template>

<script>
// https://vuejs.org/guide/components/attrs.html#disabling-attribute-inheritance
export default {
  inheritAttrs: false
}
</script>

<script setup>

/**
 * A simple wrapper for Vuetify's <v-text-field>.
 * 
 * https://dev.to/kouts/create-wrapper-components-for-vuetify-components-2aah
 * https://v3-migration.vuejs.org/breaking-changes/listeners-removed.html
 */

import { computed, useAttrs} from 'vue'

const props = defineProps({

  validator: {
    type: Object,
  },

  items: {
    type: Array,
    default: [],
  },

  required: {
    type: Boolean,
    default: false,
  },

})

const attrs = useAttrs()

const commonAttrs = computed(() => {

  // override 

  const output = {
    items: null, // don't pass this along to v-radio-group
  }

  if (props.validator) {
    output.validator = null // don't pass the validator prop along to v-radio-group
    output.errorMessages = props.validator.$errors.map(e => e.$message)
  }

  if (props.required) {
    if ('class' in attrs) {
      output.class = attrs.class + ' v-input--required'
    } else {
      output.class = 'v-input--required'
    }
  }

  return output

})

</script>
